import { ProductInfoNutrientComponentData } from '@occ/api-client';

const sortNutrientComponents = (nutrientComponents?: ProductInfoNutrientComponentData[]) => {
  if (!nutrientComponents) return [];
  return nutrientComponents.sort((a, b) => (a.sequenceNumber || 0) - (b.sequenceNumber || 0));
};

export default sortNutrientComponents;
